//кнопка вверх
$(document).ready(function () {
    $(window).scroll(function () {
        if ($(document).scrollTop() > 10) {
            $('#scroll').css('display', 'block');
        } else {
            $('#scroll').css('display', 'none');
        }
        if ($(document).scrollTop() > 25) {
            $('#block-custom-blocks-site-header-new .menu').addClass('go');
        } else {
            $('#block-custom-blocks-site-header-new .menu').removeClass('go');
        }
    });

    $('#toTop').click(function () {
        $('html, body').animate({scrollTop: $('html').offset().top}, 'slow');
        return false;
    });

    $(".second-menu li").click(function () {
        if (this.classList.contains('ifo')) {
            $("html, body").animate({scrollTop: $('#block-views-offers-block').offset().top - 156}, "slow");
        }
        if (this.classList.contains('hot')) {
            $("html, body").animate({scrollTop: $('#hot').offset().top - 176}, "slow");
        }
        if (this.classList.contains('ack')) {
            $("html, body").animate({scrollTop: $('#block-custom-blocks-block-akciya').offset().top - 156}, "slow");
        }
        if (this.classList.contains('place')) {
            $("html, body").animate({scrollTop: $('#block-custom-blocks-site-footer').offset().top - 156}, "slow");
        }

        return false;
    });

    //приплывание к форме при клике на кнопку - Подобрать тур
    $('.but_to_form').click(function () {
        $("html, body").animate({scrollTop: $('#block-custom-blocks-block-akciya .form').offset().top - 156}, "slow");
        return false;
    });


});
var map_vis = true;

$(".map-unload").mouseenter(function () {
    if (map_vis === true) {
        map_vis = false;
        createMapIframe();
        $("#map-iframe").removeClass('map-unload');
    }

});
$(".map-unload").on("tap", function () {

    if (map_vis === true) {
        map_vis = false;
        createMapIframe();
        $("#map-iframe").removeClass('map-unload');
    }
});

//Тур появляется
if (document.querySelector('#tour')) {

    var interval = 0;
    var show_interval1 = 27;
    var show_interval2 = 67;

    setInterval(updateSomeElement, 1000);
}

function updateSomeElement() {
    interval = interval + 1;
    if (interval >= 20 && interval <= show_interval1 || interval >= 60 && interval <= show_interval2) {
        $('#tour').removeClass('hide');
        $("#sign-image").css("opacity", "0");
    } else {
        $('#tour').addClass('hide');
        $("#sign-image").css("opacity", "1");
    }

}

function createMapIframe() {
    let element = document.createElement('iframe');
    // element.src = 'https://www.google.com/maps/d/u/0/edit?hl=ru&mid=1_n00sWAVqTquwQWJVfOjJ3IWGY26DgSu&ll';
    // element.src = 'https://www.google.com/maps/d/embed?mid=1_n00sWAVqTquwQWJVfOjJ3IWGY26DgSu&ll';
    element.src = 'https://www.google.com/maps/d/u/0/embed?mid=1_n00sWAVqTquwQWJVfOjJ3IWGY26DgSu';
    element.height = '333';
    document.getElementById('map-iframe').appendChild(element);


    // let src = $('.mapload').attr('data-src');
    // $('.mapload').attr('src', src);
    // $('.mapload').removeClass('vis-hide')
}


//popup message
let num = 1;
setTimeout(function () {
    if (num < 3) {
        $(".message-popup").addClass('open');
        setTimeout(function () {
            $(".message-popup").removeClass('open');
            num++
            if (num <= 3) {
                openPopup();
            }

        }, 10000);
    }

}, 10000);

$('.message-popup .close-popup, .message-popup .wind-bg').click(function () {
    $(".message-popup").removeClass('open');
    num++
    if (num <= 3) {
        openPopup();
    }
});

function openPopup() {
    setTimeout(function () {

        $(".message-popup").addClass('open');

        if (num < 3) {
            setTimeout(function () {
                num++
                openPopup();
            }, 10000);
        }
        setTimeout(function () {
            $(".message-popup").removeClass('open');
        }, 10000);

    }, 60000);
}

$(document).ready(function () {
    $('.tour-block-slider').slick({
        dots: false,
        slidesToScroll: 1,
        slidesToShow: 5,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        arrows: true,
        speed: 500,
        cssEase: 'ease-in-out',
        pauseOnDotsHover: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }
            }],
    });
    $('.early-booking-tour-block-slider').slick({
        dots: false,
        slidesToScroll: 1,
        slidesToShow: 5,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        arrows: true,
        speed: 500,
        cssEase: 'ease-in-out',
        pauseOnDotsHover: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }
            }],
    });
});


// WEBPACK FOOTER //
// ./resources/assets/js/snippets/common.js